export const SET_AFTERCARE_LIST = 'SET_AFTERCARE_LIST';
export const CLEAR_AFTERCARE_SESSION_NAME = 'CLEAR_AFTERCARE_SESSION_NAME';
export const FETCHED_AFTERCARE_SESSION_NAME = 'FETCHED_AFTERCARE_SESSION_NAME';
export const SET_AFTERCARE_ADDONS_USED = 'SET_AFTERCARE_ADDONS_USED';
export const CLEAR_AFTERCARE_ADDONS_USED = 'CLEAR_AFTERCARE_ADDONS_USED';
export const SET_AFTERCARE_FREE_DAYS_ENROLL_CHILD_ROSTERS = 'SET_AFTERCARE_FREE_DAYS_ENROLL_CHILD_ROSTERS';
export const CLEAR_AFTERCARE_FREE_DAYS_ENROLL_CHILD_ROSTERS = 'CLEAR_AFTERCARE_FREE_DAYS_ENROLL_CHILD_ROSTERS';
export const SET_AFTERCARE_ID = 'SET_AFTERCARE_ID';
export const CLEAR_AFTERCARE_ID = 'CLEAR_AFTERCARE_ID';
export const SET_AFTERCARE_DAY_ID = 'SET_AFTERCARE_DAY_ID';
export const CLEAR_AFTERCARE_DAY_ID = 'CLEAR_AFTERCARE_DAY_ID';
export const SET_AFTERCARE_SESSION_DAY = 'SET_AFTERCARE_SESSION_DAY';
export const CLEAR_AFTERCARE_SESSION_DAY = 'CLEAR_AFTERCARE_SESSION_DAY';


// WEBPACK FOOTER //
// ./src/store/modules/aftercare-page/mutations.js